import { mask } from './remask'

export const formatPhone = (phone: string): string => {
  if (/^0800|^0300/.test(phone)) {
    return mask(phone, '9999 999 9999')
  } else {
    return mask(phone, ['(99) 9999-9999', '(99) 99999-9999'])
  }
}
